import type { Environment, Vehicle } from '@rcs/data-schema';
import { totalMass } from '@rcs/data-schema';
import type { SimulationOptions } from '@rcs/physics';

/**
 * 車両と環境から、走行シミュレーションの条件を作る。
 *
 * - 環境：重力加速度・空気密度
 * - 車両：編成の総質量・空気抵抗係数・前面投影面積・転がり抵抗係数
 *
 * @param base 初速などの、追加の条件
 */
export function rideSimulation(
  vehicle: Vehicle,
  environment: Pick<Environment, 'physics'>,
  base: SimulationOptions = {},
): SimulationOptions {
  return {
    ...base,
    gravity: environment.physics.gravity,
    resistance: {
      mass: totalMass(vehicle),
      dragCoefficient: vehicle.dragCoefficient,
      frontalArea: vehicle.frontalArea,
      rollingResistance: vehicle.rollingResistance,
      airDensity: environment.physics.airDensity,
    },
  };
}
